import * as React from 'react'
import { MODULE_TITLES } from '@/constants/modules'

interface ContainerUIState {
  containerIsOpen: boolean
  showContent: boolean
  whatsappIsOff: boolean
  generalModule: boolean
  title: string
}

interface ContainerUIActions {
  setContainerIsOpen: (value: React.SetStateAction<boolean>) => void
  setShowContent: (value: React.SetStateAction<boolean>) => void
  setWhatsappIsOff: (value: boolean) => void
  setGeneralModule: (value: boolean) => void
  setTitle: (value: string) => void
  handleOpenContainer: () => void
}

type ContainerUIContextType = ContainerUIState & ContainerUIActions

const ContainerUIContext = React.createContext<ContainerUIContextType | null>(null)

interface ContainerUIProviderProps {
  children: React.ReactNode
}

export const ContainerUIProvider: React.FC<ContainerUIProviderProps> = ({ children }) => {
  const [containerIsOpen, setContainerIsOpen] = React.useState(false)
  const [showContent, setShowContent] = React.useState(false)
  const [whatsappIsOff, setWhatsappIsOff] = React.useState(true)
  const [generalModule, setGeneralModule] = React.useState(true)
  const [title, setTitle] = React.useState(MODULE_TITLES.general as string)

  const handleOpenContainer = React.useCallback(() => {
    setContainerIsOpen((prev) => !prev)
  }, [])

  const contextValue = React.useMemo(
    (): ContainerUIContextType => ({
      containerIsOpen,
      showContent,
      whatsappIsOff,
      generalModule,
      title,
      setContainerIsOpen,
      setShowContent,
      setWhatsappIsOff,
      setGeneralModule,
      setTitle,
      handleOpenContainer,
    }),
    [containerIsOpen, showContent, whatsappIsOff, generalModule, title, handleOpenContainer]
  )

  return <ContainerUIContext.Provider value={contextValue}>{children}</ContainerUIContext.Provider>
}

export const useContainerUI = (): ContainerUIContextType => {
  const context = React.useContext(ContainerUIContext)
  if (!context) {
    throw new Error('useContainerUI must be used within a ContainerUIProvider')
  }
  return context
}
